import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useBlocker } from "react-router-dom";

import { useHubSnackBar } from "../../../hooks";
import { WarningNavigateDialog } from "../../../dialogs";

import { StyledDetailsCardStacks } from "../styles";
import { getUserLocation } from "../../../redux";
import { connect } from "react-redux";
import PartRoutingDetails from "./PartRoutingDetails";

const error = {
  title: "Action Required",
  message:
    "Some required fields are missing or invalid. In order to submit, please resolve these errors.",
};

const PartRouting = ({ defaultLocation = 1, locationId, setLocationId }) => {
  // Use lifted state from parent if available, otherwise use local state
  const [localValue, setLocalValue] = useState(defaultLocation);
  const value = locationId !== undefined ? locationId : localValue;
  const setValue = setLocationId || setLocalValue;

  const { formState } = useFormContext();
  const { errors, dirtyFields } = formState;
  const hasErrors = !!Object.keys(errors).length;

  const { addSnackbarError } = useHubSnackBar();

  useEffect(() => {
    hasErrors && addSnackbarError(error);
  }, [hasErrors]);

  // Only block navigation if there are actual dirty fields
  // This prevents false positives from form resets
  const shouldBlock = Object.entries(dirtyFields).some(([_, val]) => val);
  const blocker = useBlocker(shouldBlock);
  const handleDialogClose = () => blocker.reset();
  const handleDialogSubmit = () => blocker.proceed();

  // Unmount Reset Blocker
  useEffect(() => {
    return () => {
      blocker?.reset && blocker.reset();
    };
  }, []);

  return (
    <>
      <StyledDetailsCardStacks>
        <PartRoutingDetails value={value} setValue={setValue} />
      </StyledDetailsCardStacks>
      <WarningNavigateDialog
        isOpen={blocker.state === "blocked"}
        onClose={handleDialogClose}
        onSubmit={handleDialogSubmit}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export default connect(mapStateToProps)(PartRouting);
